import { render } from "./PeoplePicker.vue?vue&type=template&id=ece859e8"
import script from "./PeoplePicker.vue?vue&type=script&lang=js"
export * from "./PeoplePicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__